module.exports = __webpack_public_path__ + "static/media/mountain10.0e50943c.jpg";